module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Adopt"
  }, [(_vm.animal.id) ? _c('slider', {
    attrs: {
      "items": _vm.items
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60d51970"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Adopt.vue
// module id = 429
// module chunks = 1